import React from "react";
import { Card } from "@outpave/ds";
import type { StatCardTrend } from "@outpave/ds";
import BalanceAmount from "components/common/BalanceAmount";
import TrendChart, { TrendPoint } from "components/common/TrendChart";

interface TrendPanelProps {
  title: string;
  /** The headline figure, already formatted. Its cents are raised. */
  value: string;
  valueLoading?: boolean;
  /** The window the chart covers. */
  caption: string;
  /** Chips at the end of the caption line, such as the money in and out over the window. */
  trend?: StatCardTrend | StatCardTrend[];
  series: TrendPoint[];
  formatValue: (value: number) => string;
  loading?: boolean;
}

/** A headline figure over its trend, the layout of the prototype's balance card. */
const TrendPanel: React.FC<TrendPanelProps> = ({
  title,
  value,
  valueLoading = false,
  caption,
  trend,
  series,
  formatValue,
  loading = false,
}) => (
  <Card
    variant="outlined"
    title={title}
    value={
      valueLoading ? (
        ""
      ) : (
        <BalanceAmount
          value={value}
          variant="inherit"
          centsSize="var(--type-size-lg)"
        />
      )
    }
    caption={caption}
    trend={trend}
    loading={valueLoading}
    sx={{ height: "100%" }}
  >
    <TrendChart series={series} formatValue={formatValue} loading={loading} />
  </Card>
);

export default TrendPanel;
